/**
 * @module "ethpm/registries"
 */

export * from './service';
